import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Trophy } from 'lucide-react';

const pctColor = p => (p == null ? 'text-white/30' : p >= 80 ? 'text-[#6BCB77]' : p >= 50 ? 'text-amber-300' : 'text-red-400');
const fmtLate = h => (h == null ? '—' : h < 24 ? `${Math.round(h)} h` : `${(h / 24).toFixed(1)} días`);

export const FollowUpRanking = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get('/dashboard/follow-up-ranking').then(setRows).catch(() => setRows([])); }, []);
  if (!rows) return null;

  return (
    <div data-testid="follow-up-ranking" className="bg-[#0A1F1A] rounded-2xl border border-white/5 p-5 lg:p-6">
      <h2 className="font-outfit text-base lg:text-lg font-medium text-white flex items-center gap-2 mb-1">
        <Trophy size={18} strokeWidth={1.5} className="text-[#A38560]" /> Cumplimiento de seguimientos
      </h2>
      <p className="text-xs text-white/40 mb-4">Seguimientos hechos a tiempo, atraso promedio de los que se vencieron y estado actual por asesor.</p>
      {rows.length === 0 ? <p className="text-sm text-white/40">Aún no hay seguimientos registrados.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[560px]">
            <thead>
              <tr className="text-[10px] uppercase tracking-wider text-white/40 text-left">
                <th className="py-2 pr-2">#</th><th className="py-2 pr-2">Asesor</th><th className="py-2 px-2 text-right">A tiempo</th>
                <th className="py-2 px-2 text-right">Atraso promedio</th><th className="py-2 px-2 text-right">Vencidos ahora</th><th className="py-2 pl-2 text-right">Sin fecha</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.broker_id} data-testid={`ranking-row-${r.broker_id}`} className="border-t border-white/5">
                  <td className="py-2.5 pr-2 text-white/40 tabular-nums">{i + 1}</td>
                  <td className="py-2.5 pr-2 text-white">{r.broker_name}</td>
                  <td className="py-2.5 px-2 text-right tabular-nums">
                    <span className={`font-semibold ${pctColor(r.on_time_pct)}`}>{r.on_time_pct == null ? '—' : `${r.on_time_pct}%`}</span>
                    <span className="text-[10px] text-white/30 ml-1">({r.on_time}/{r.completed})</span>
                  </td>
                  <td className="py-2.5 px-2 text-right tabular-nums text-white/70">{fmtLate(r.avg_late_hours)}</td>
                  <td className={`py-2.5 px-2 text-right tabular-nums ${r.overdue_now ? 'text-red-400 font-semibold' : 'text-white/40'}`}>{r.overdue_now}</td>
                  <td className={`py-2.5 pl-2 text-right tabular-nums ${r.missing ? 'text-amber-300 font-semibold' : 'text-white/40'}`}>{r.missing}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
